import { useState } from 'react'

import { PartnerConfigContext } from '../PartnerConfigContext/PartnerConfigContext'

import { PartnerConfigContextControllerProps } from './PartnerConfigContextController.types'
import { DonationSessionDetails } from '@percent/hosted-donation-gateway/app/DonationForm/DonationForm/DonationForm.types'

export function PartnerConfigContextController({ children }: PartnerConfigContextControllerProps) {
  const [partnerConfig, setPartnerConfig] = useState<DonationSessionDetails | undefined>()

  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <PartnerConfigContext.Provider value={{ partnerConfig, setPartnerConfig }}>
      {children}
    </PartnerConfigContext.Provider>
  )
}
